const state = {
    id: 0,
    url: "",
    description: "",
    title: "",
    grade: [],
    interest: "ALL",
    mapel: "",
    thumbnail: "",
    type: "",
    source: "",
    duration: "",
    bab: "",
    subbab: "",
    subsubbab: "",
    kurikulum: "",
    status: "",
    user_groups: [],
};

const mutations = {
    video_reset: function (state) {
        state.id = 0;
        state.url = "";
        state.description = "";
        state.title = "";
        state.grade = [];
        state.interest = "ALL";
        state.mapel = "";
        state.thumbnail = "";
        state.type = "";
        state.source = "";
        state.duration = "";
        state.bab = "";
        state.subbab = "";
        state.subsubbab = "";
        state.kurikulum = "";
        state.status = "";
        state.user_groups = [];
    },

    video_init: function (state, payload) {
        state.id = payload.id;
        state.url = payload.url;
        state.description = payload.description;
        state.title = payload.title;
        state.grade = payload.grade;
        state.interest = payload.interest;
        state.mapel = payload.mapel;
        state.thumbnail = payload.thumbnail;
        state.type = payload.type;
        state.source = payload.source;
        state.duration = payload.duration;
        state.bab = payload.bab;
        state.subbab = payload.subbab;
        state.subsubbab = payload.subsubbab;
        state.kurikulum = payload.kurikulum;
        state.status = payload.status;
        state.user_groups = payload.user_groups;
    },

    video_set_id: function (state, payload) {
        state.id = payload;
    },

    video_set_url: function (state, payload) {
        state.url = payload;
    },

    video_set_description: function (state, payload) {
        state.description = payload;
    },

    video_set_title: function (state, payload) {
        state.title = payload;
    },

    video_set_grade: function (state, payload) {
        state.grade = payload;
    },

    video_set_interest: function (state, payload) {
        state.interest = payload;
    },

    video_set_mapel: function (state, payload) {
        state.mapel = payload;
    },

    video_set_user_group: function (state, payload) {
        state.user_groups = payload;
    },

    video_set_thumbnail: function (state, payload) {
        state.thumbnail = payload;
    },

    video_set_source: function (state, payload) {
        state.source = payload;
    },

    video_set_type: function (state, payload) {
        state.type = payload;
    },

    video_set_duration: function (state, payload) {
        state.duration = payload;
    },

    video_set_bab: function (state, payload) {
        state.bab = payload;
    },

    video_set_subbab: function (state, payload) {
        state.subbab = payload;
    },

    video_set_subsubbab: function (state, payload) {
        state.subsubbab = payload;
    },

    video_set_kurikulum: function (state, payload) {
        state.kurikulum = payload;
    },

    video_set_status: function (state, payload) {
        state.status = payload;
    },
};

const getters = {};

export default { state, mutations, getters };



// WEBPACK FOOTER //
// ./src/modules/vd_pembelajaran/stores/video.js